import JSZip from 'jszip';

export type ZipEntry = { filename: string; blob: Blob };

export async function buildZip(entries: ZipEntry[]): Promise<Blob> {
	const zip = new JSZip();
	for (const e of entries) {
		zip.file(e.filename, e.blob);
	}
	return await zip.generateAsync({ type: 'blob' });
}


